import { Badge } from '@startupquickstart/frontend';
import type { ComponentPropsWithoutRef } from 'react';

type AmenityStatus = 'published' | 'draft' | 'needs_review';

interface AmenityStatusBadgeProps extends Omit<ComponentPropsWithoutRef<typeof Badge>, 'variant'> {
  status: AmenityStatus;
}

function getStatusConfig(status: AmenityStatus) {
  switch (status) {
    case 'published':
      return {
        variant: 'default' as const,
        label: 'Published',
      };
    case 'draft':
      return {
        variant: 'secondary' as const,
        label: 'Draft',
      };
    case 'needs_review':
      return {
        variant: 'destructive' as const,
        label: 'Needs Review',
      };
    default:
      return {
        variant: 'outline' as const,
        label: 'Unknown',
      };
  }
}

export function AmenityStatusBadge({ status, className, ...props }: AmenityStatusBadgeProps) {
  const { variant, label } = getStatusConfig(status);

  return (
    <Badge variant={variant} className={className} {...props}>
      {label}
    </Badge>
  );
}
